import React, { useState } from 'react';
import { Button, ButtonGroup, Card, Text } from '@fragments';
import {
    IconBuildingBank,
    IconChevronLeft,
    IconChevronRight,
    IconCreditCard,
    IconHome,
    IconPlus,
    IconShoppingCart,
    IconWifi,
} from '@tabler/icons-react';
import './styles.scss';

const DETAILS = [
    { label: 'Card Number', value: '•••• 1234' },
    { label: 'Expiry Date', value: '06/27' },
    { label: 'CVC', value: '•••' },
    { label: 'Spending Limit', value: 'US$ 12.000,00' },
];

const TRANSACTIONS = [
    {
        id: 'stock-dividend',
        Icon: IconBuildingBank,
        name: 'Stock Dividend',
        description: 'Payment from stock investments.',
        amount: '$1,500.00',
        date: 'September 15, 2024',
    },
    {
        id: 'rental-income',
        Icon: IconHome,
        name: 'Rental Income',
        description: 'Rental payment from Mr. Dudley.',
        amount: '$800.00',
        date: 'September 17, 2024',
        accent: true,
    },
    {
        id: 'grocery-shopping',
        Icon: IconShoppingCart,
        name: 'Grocery Shopping',
        description: 'Purchase of monthly groceries.',
        amount: '-$84.14',
        date: 'September 16, 2024',
    },
];

const TAB_OPTIONS = [
    { label: 'Virtual', value: 'virtual' },
    { label: 'Physical', value: 'physical' },
];

export default function MyCardsCard() {
    const [tab, setTab] = useState('virtual');

    return (
        <Card
            flat
            noBodyPadding
            title="My Cards"
            icon={<IconCreditCard />}
            action={
                <Button variant="text" color="inverse" size="small" startIcon={<IconPlus />}>
                    Add Card
                </Button>
            }
        >
            <div className="mm">
                <ButtonGroup
                    grow
                    size="small"
                    options={TAB_OPTIONS}
                    value={tab}
                    onChange={setTab}
                />

                <div className="mm-card" role="img" aria-label="Savings card balance $16,058.94">
                    <div className="mm-card__top">
                        <span className="mm-card__brand-dot" aria-hidden="true" />
                        <IconWifi className="mm-card__wifi" />
                        <span className="mm-card__status">Active</span>
                        <span className="mm-card__network" aria-hidden="true">
                            <span />
                            <span />
                        </span>
                    </div>

                    <div className="mm-card__bottom">
                        <Text.caption contrast={6}>Savings Card</Text.caption>
                        <Text.h2 weight={500} contrast={10}>$16,058.94</Text.h2>
                    </div>

                    <div className="mm-card__pager" aria-hidden="true">
                        <button type="button" disabled><IconChevronLeft /></button>
                        <button type="button"><IconChevronRight /></button>
                    </div>
                </div>

                <div className="mm__details">
                    {DETAILS.map(({ label, value }) => (
                        <div className="mm__detail" key={label}>
                            <Text.span contrast={6}>{label}</Text.span>
                            <Text.label contrast={10}>{value}</Text.label>
                        </div>
                    ))}
                </div>

                <div className="mm__actions">
                    <Button color="overlay" size="small">Unhide</Button>
                    <Button color="overlay" size="small">Adjust Limit</Button>
                    <Button color="overlay" size="small">More</Button>
                </div>

                <div className="mm__transactions">
                    <Text.subheading contrast={6}>Recent Transactions</Text.subheading>
                    <ul className="mm__transaction-list">
                        {TRANSACTIONS.map(({ id, Icon, name, description, amount, date, accent }) => (
                            <li key={id}>
                                <button type="button" className="mm__transaction">
                                    <span className={`mm__tx-icon${accent ? ' mm__tx-icon--accent' : ''}`}>
                                        <Icon />
                                    </span>
                                    <span className="mm__tx-copy">
                                        <Text.label contrast={9} maxLines={1}>{name}</Text.label>
                                        <Text.caption contrast={6} maxLines={1}>{description}</Text.caption>
                                    </span>
                                    <span className="mm__tx-meta">
                                        <Text.label contrast={10}>{amount}</Text.label>
                                        <Text.caption contrast={6}>{date}</Text.caption>
                                    </span>
                                    <IconChevronRight className="mm__tx-chevron" />
                                </button>
                            </li>
                        ))}
                    </ul>

                    <Button variant="inverse" size="medium" fullWidth startIcon={<IconCreditCard />}>
                        See All Transactions
                    </Button>
                </div>
            </div>
        </Card>
    );
}
